// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"411657e7","455":"c6acd2fc"}[chunkId] + ".chunk.js";
};